import React, { useState } from 'react';
import Layout from "Layout";
import { mixGetV2 } from 'services/mixin';
import { Input, Select, Button, message } from 'antd';

const Dashboard: React.FC = () => {
    const [rr, setrr] = useState(2)
    const [listRiskPrecent, setListRiskPrecent] = useState([0.0025,0.003,0.0035,0.004,0.0045,0.005,0.0055,0.006,0.0065,0.007,0.0075,0.008,0.0085,0.009,0.0095,0.01,0.015,0.02])
    const [numberTrades, setNumberTrades] = useState(50)
    const [listWinRate, setListWinRate] = useState([0.3,0.4,0.5,0.6,0.7,0.8,0.9])
    const [listData, setListData] = useState([])

    const calculate = async () => {
        if (!rr || !listRiskPrecent || !numberTrades || !listWinRate) {
            message.error('Please fill in all fields');
            return;
        }
        const res = await mixGetV2('/tool/simulator-matrix-rr-risk', {
            matrix_rr: rr,
            matrix_list_risk_percent: listRiskPrecent.toString(),
            matrix_number_trades: numberTrades,
            matrix_list_winrate: listWinRate.toString()
        });
        setListData(res.result_matrix);
    };

    const find1 = (risk: any) => {
        const findData = listData.find((x: any) => x.risk_percent === Number(risk)) as any
        return findData ? findData.reward_percent : 0;
    }

    const find2 = (risk: any, winrate: any) => {
        const findData = listData.find((x: any) => x.risk_percent === Number(risk) && x.winrate === Number(winrate)) as any
        return findData ? findData.profit_percent : 0;
    }

    const find0 = (winrate: any) => {
        const findData = listData.find((x: any) => x.winrate === Number(winrate)) as any
        return findData ? findData.count_win_trades : 0;
    }

    return (
        <Layout>
            <div className='MaTrixRiskReward'>
                <div className='list-from-item'>
                    <div className='f-item'>
                        <label>Matrix rr</label>
                        <Input
                            value={rr}
                            onChange={(e: any) => {
                                setrr(e.target.value)
                                setListData([])
                            }}
                            placeholder='Matrix rr'
                        />
                    </div>
                    <div className='f-item'>
                        <label>Matrix list risk percent</label>
                        <Select
                            value={listRiskPrecent}
                            mode="tags"
                            style={{ width: '100%' }}
                            placeholder="Matrix list risk percent"
                            onChange={(e) => {
                                setListRiskPrecent(e)
                                setListData([])
                            }}
                            options={[]}
                        />
                    </div>

                    <div className='f-item'>
                        <label>Matrix number trades</label>
                        <Input
                            value={numberTrades}
                            onChange={(e: any) => {
                                setNumberTrades(e.target.value)
                                setListData([])
                            }}
                            placeholder='Matrix number trades'
                        />
                    </div>

                    <div className='f-item'>
                        <label>Matrix list winrate</label>
                        <Select
                            value={listWinRate}
                            mode="tags"
                            style={{ width: '100%' }}
                            placeholder="Matrix list winrate"
                            onChange={(e) => {
                                setListWinRate(e)
                                setListData([])
                            }}
                            options={[]}
                        />
                    </div>
                </div>
                <div className='btn-matrix'>
                    <div className='button-x' onClick={calculate}>Run matrix</div>
                </div>

                <div className='table-responsive'>
                    {listData.length > 0 &&
                        <table className='table-custom'>
                            <thead>
                                <tr>
                                    <th rowSpan={3}>Reward (%)</th>
                                    <th rowSpan={3}>Risk (%)</th>
                                    <th rowSpan={3}>RR</th>
                                    <th colSpan={listWinRate.length}>
                                        <div className='tb-title'>
                                            Win rate
                                        </div>
                                    </th>
                                </tr>
                                <tr>
                                    {Array.isArray(listWinRate) && listWinRate.map((rate, idx) => (
                                        <th key={idx}>{(Number(rate) * 100).toFixed(0)}%</th>
                                    ))}
                                </tr>
                                <tr>
                                    {Array.isArray(listWinRate) && listWinRate.map((rate, idx) => (
                                        <th key={idx}>{find0(rate)}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(listRiskPrecent) && listRiskPrecent.map((risk, idx) => (
                                    <tr key={idx}>
                                        <td className='blue'>{(Number(find1(risk)) * 100).toFixed(2)}%</td>
                                        <td className='red'>-{(Number(risk) * 100).toFixed(2)}%</td>
                                        <td>{rr}</td>
                                        {Array.isArray(listWinRate) && listWinRate.map((rate, idx) => (
                                            <th className={Number(find2(risk, rate)) < 0 ? 'red' : 'blue'} key={`${rate}-${idx}`}>{(Number(find2(risk, rate)) * 100).toFixed(2)}%</th>
                                        ))}

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    }
                </div>
            </div>
        </Layout>
    )
}
export default Dashboard